import { render, staticRenderFns } from "./VideoPlayerFive.vue?vue&type=template&id=4a001b9a&"
import script from "./VideoPlayerFive.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerFive.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerFive.vue?vue&type=style&index=0&id=4a001b9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports